/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Thin_Robin_WaitInputs */

const en_soft_thin_robin_wait = /** @type {(inputs: Soft_Thin_Robin_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment analysis in progress`)
};

const de_soft_thin_robin_wait = /** @type {(inputs: Soft_Thin_Robin_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentaranalyse läuft`)
};

/**
* | output |
* | --- |
* | "Comment analysis in progress" |
*
* @param {Soft_Thin_Robin_WaitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_thin_robin_wait = /** @type {((inputs?: Soft_Thin_Robin_WaitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Thin_Robin_WaitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_thin_robin_wait(inputs)
	return de_soft_thin_robin_wait(inputs)
});